export function containerMapper(container) {
  //revisit later when/if we have v4 payload
  container.avatarImage = container.images?.medium?.url;

  return container;

}
